import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.1965 1.36332C1.22107 1.1551 1.29393 0.955488 1.40927 0.780393C1.52461 0.605297 1.67924 0.459554 1.86085 0.354772C2.04246 0.24999 2.24603 0.189065 2.45534 0.176848C2.66465 0.164632 2.87393 0.201462 3.0665 0.284406C4.04 0.700573 6.22166 1.68966 8.99 3.28741C11.7592 4.88607 13.7072 6.28216 14.5532 6.91557C15.2756 7.45732 15.2774 8.53166 14.5542 9.07524C13.7163 9.70499 11.7922 11.0827 8.99 12.7016C6.185 14.3204 4.029 15.2976 3.06466 15.7082C2.23416 16.063 1.30466 15.5249 1.1965 14.6293C1.07 13.5825 0.833496 11.2056 0.833496 7.99541C0.833496 4.78707 1.06908 2.41107 1.1965 1.36332Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }